/* image-compress.js — robust: multi-form detection + compression + fallback mirror */
(function(){
  // ---- Compression settings (safe defaults) ----
  const START_MAX_DIM   = 1400;
  const MIN_MAX_DIM     = 800;
  const START_QUALITY   = 0.75;
  const MIN_QUALITY     = 0.50;
  const TARGET_PER_FILE = 0.35 * 1024 * 1024;  // ~0.9 MB
  const HARD_PER_FILE   = 0.50 * 1024 * 1024;  // absolute ceiling
  // ----------------------------------------------

  const SELECTOR_INPUTS = '.twelve-months input[type="file"], .personalize input[type="file"]';

  // run on initial load + section reloads
  onReady(bindAll);
  document.addEventListener('shopify:section:load', bindAll);

  function onReady(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function bindAll(){
    const allForms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    const allInputs = Array.from(document.querySelectorAll(SELECTOR_INPUTS));

    // Basic banner so you know we’re live
    // ensureBanner().textContent = `compress.js: forms=${allForms.length}, inputs=${allInputs.length}`;

    if (!allInputs.length) return;

    // Attach to every input exactly once
    allInputs.forEach((inp) => {
      if (inp.dataset.icBound === '1') return;
      inp.dataset.icBound = '1';
      if (!inp.hasAttribute('accept')) inp.setAttribute('accept','image/*');

      const msg = ensureMsg(inp);

      inp.addEventListener('change', async () => {
        const f = inp.files && inp.files[0];
        if (!f) return;
        // msg.className = 'ic-msg';
        // msg.textContent = `Optimizing ${fmt(f.size)}…`;
        try{
          await tick();
          const out = await compressAdaptive(f);
          replaceFile(inp, out);
          // msg.className = 'ic-msg ic-ok';
          // msg.textContent = `Ready: ${fmt(f.size)} → ${fmt(out.size)}`;
        }catch(err){
          msg.className = 'ic-msg ic-err';
          msg.textContent = `Could not optimize: ${err.message || 'error'}`;
        }
      }, { passive:true });
    });

    // Bind submit on every /cart/add form
    allForms.forEach((form) => {
      if (form.dataset.icSubmitBound === '1') return;
      form.dataset.icSubmitBound = '1';

      form.addEventListener('submit', (e) => {
        // Figure out which inputs belong to THIS form
        const myInputs = allInputs.filter((inp) => form.contains(inp));

        if (!myInputs.length){
          // Fallback: inputs are outside; mirror any selected Files into THIS form so they submit.
          const dangling = allInputs.filter(inp => inp.files && inp.files.length);
          if (dangling.length){
            mirrorFilesIntoForm(form, dangling);
            console.warn('[compress] mirrored', dangling.length, 'file input(s) into form because they were outside.');
          } else {
            // nothing to mirror
          }
        }
        // log sizes
        try {
          const files = (myInputs.length ? myInputs : allInputs).map(i => i.files && i.files[0]).filter(Boolean);
          const total = files.reduce((s,f)=> s + f.size, 0);
          console.log('[compress] submit total:', fmt(total), files.map(f=>fmt(f.size)));
        } catch(_){}
      });
    });
  }

  // ---- UI helpers ----
  function ensureBanner(){
    let el = document.querySelector('.ic-debug-banner');
    if (!el){
      el = document.createElement('div');
      el.className = 'ic-debug-banner';
      el.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:99999;background:#0b7f38;color:#fff;padding:6px 10px;border-radius:6px;font:12px/1.2 system-ui;box-shadow:0 2px 12px rgba(0,0,0,.25)';
      document.body.appendChild(el);
    }
    return el;
    }
  function ensureMsg(input){
    if (input._icMsg) return input._icMsg;
    const el = document.createElement('div');
    el.className = 'ic-msg';
    el.style.cssText = 'font:12px/1.4 system-ui;margin-top:6px;color:#666';
    input.insertAdjacentElement('afterend', el);
    input._icMsg = el;

    // Show whether this input is in a form
    const inForm = !!input.closest('form[action*="/cart/add"]');
    if (!inForm){
      el.textContent = '⚠ This input is NOT inside the Add-to-Cart form. We will mirror it on submit.';
      el.style.color = '#b00020';
      el.className = 'ic-msg ic-err';
    }
    return el;
  }
  const fmt = (n)=> n<1024? n+' B' : (n<1024*1024? (n/1024).toFixed(1)+' KB' : (n/1024/1024).toFixed(1)+' MB');
  const tick = ()=> new Promise(r=>setTimeout(r,0));

  // ---- Compression core ----
  async function compressAdaptive(file){
    const bmp = await readBitmap(file);
    let maxDim = Math.min(START_MAX_DIM, Math.max(bmp.width, bmp.height));
    let q = START_QUALITY;
    let best = null;

    for (let attempt=0; attempt<8; attempt++){
      const scale = Math.min(1, maxDim / Math.max(bmp.width, bmp.height));
      const w = Math.max(1, Math.round(bmp.width * scale));
      const h = Math.max(1, Math.round(bmp.height * scale));
      const blob = await rasterToBlob(bmp, w, h, q);
      if (!best || blob.size < best.size) best = blob;

      if (blob.size <= TARGET_PER_FILE) break;

      if (q > MIN_QUALITY) {
        q = Math.max(MIN_QUALITY, q - 0.12);
      } else if (maxDim > MIN_MAX_DIM) {
        maxDim = Math.max(MIN_MAX_DIM, Math.round(maxDim * 0.85));
        q = Math.min(START_QUALITY, q + 0.08);
      } else {
        if (best.size > HARD_PER_FILE){
          const c2 = Math.max(1, Math.round(maxDim * 0.85));
          const ratio = bmp.height / bmp.width;
          const b2 = await rasterToBlob(bmp, c2, Math.round(c2 * ratio), MIN_QUALITY);
          if (b2 && b2.size < best.size) best = b2;
        }
        break;
      }
      await tick();
    }

    const nameBase = (file.name || 'photo').replace(/\.[^.]+$/,'');
    return new File([best], nameBase + '.jpg', { type: 'image/jpeg' });
  }

  async function readBitmap(file){
    try { return await createImageBitmap(file); }
    catch {
      const dataUrl = await new Promise((res, rej) => {
        const fr = new FileReader(); fr.onload=()=>res(fr.result); fr.onerror=()=>rej(new Error('Cannot read image')); fr.readAsDataURL(file);
      });
      const img = await new Promise((res, rej) => {
        const i = new Image(); i.onload=()=>res(i); i.onerror=()=>rej(new Error('Unsupported image')); i.src = dataUrl;
      });
      return { width: img.naturalWidth, height: img.naturalHeight, _img: img };
    }
  }
  async function rasterToBlob(bitmap, w, h, quality){
    if (typeof OffscreenCanvas !== 'undefined'){
      const c = new OffscreenCanvas(w, h);
      const ctx = c.getContext('2d', {alpha:false});
      if (bitmap._img) ctx.drawImage(bitmap._img, 0, 0, w, h); else ctx.drawImage(bitmap, 0, 0, w, h);
      return await c.convertToBlob({ type: 'image/jpeg', quality });
    } else {
      const c = document.createElement('canvas'); c.width=w; c.height=h;
      const ctx = c.getContext('2d', {alpha:false});
      if (bitmap._img) ctx.drawImage(bitmap._img, 0, 0, w, h); else ctx.drawImage(bitmap, 0, 0, w, h);
      return await new Promise(res => c.toBlob(res, 'image/jpeg', quality));
    }
  }

  function replaceFile(input, file){
    const dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
  }

  // ---- Fallback: mirror files into the submitting form if inputs are outside ----
  function mirrorFilesIntoForm(form, inputs){
    inputs.forEach((src, idx) => {
      const f = src.files && src.files[0];
      if (!f) return;

      // create a hidden file input clone with same name inside the form
      // (clone File via DataTransfer; browsers allow this)
      const clone = document.createElement('input');
      clone.type = 'file';
      clone.name = src.name;       // preserve properties[...] key
      clone.style.display = 'none';
      form.appendChild(clone);

      const dt = new DataTransfer();
      dt.items.add(f);
      clone.files = dt.files;
    });
  }
})();
